import { Modal } from '@buy-viasat/react/src/components/Modal';
import { Txt, Surface, useBreakpoints } from '@vst/beam';
import { LocationOn } from '@vst/beam-icons/icons';

import { useTranslation } from 'react-i18next';

import styles from './shippingAddressNotVerifiedModal.module.scss';

type ShippingAddressNotVerifiedModalProps = {
  primaryAction: () => void;
  secondaryAction: () => void;
  suggestedAddressText: string;
};

export const ShippingAddressNotVerifiedModal = ({
  primaryAction,
  secondaryAction,
  suggestedAddressText,
}: ShippingAddressNotVerifiedModalProps) => {
  const { viewport } = useBreakpoints();
  const { t } = useTranslation(['personalInformation']);

  return (
    <Modal
      headerIcon={LocationOn}
      colorIcon={'teal_600'}
      headerTitle={t('personalInformation.ShippingAddressNotVerifiedModal.titleText')}
      primaryLabelText={t('personalInformation.common.AddressNotVerifiedModal.confirmButtonText')}
      secondaryLabelText={t('personalInformation.common.AddressNotVerifiedModal.closeButtonText')}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showSecondaryButtonAsLink={true}
      hideCloseButton={!viewport.smallerOrWithin.sm}
      data-testid="ShippingAddressNotVerifiedModal"
    >
      <>
        <Txt variant={'bodySmallRegular'} data-testid="AddressNotVerifiedModalBodyText">
          {t('personalInformation.ShippingAddressNotVerifiedModal.bodyText')}
        </Txt>
        <Surface
          variant="secondary"
          radius={'8px'}
          className={styles['suggestedAddress']}
          data-testid="AddressNotVerifiedModalSuggestedAddressContainer"
        >
          <Txt variant={'bodySmallBold'} data-testid="AddressNotVerifiedModalSuggestedAddressText">
            {suggestedAddressText}
          </Txt>
        </Surface>
      </>
    </Modal>
  );
};
